namespace TotalPoll {
    import ISCEService = angular.ISCEService;
    import IScope = angular.IScope;
    import MediaUploadService = TotalCore.Common.Providers.MediaUploadService;
    import EmbedService = TotalCore.Common.Providers.EmbedService;
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'choice-component-template',
        bindings: {
            item: '=',
            index: '=',
            onDelete: '&',
            onConvert: '&',
            onOverrideVotes: '&',
        }
    })
    class ChoiceComponent {
        public embed;
        public index: number;
        public item;
        public processing = false;
        public questions = this.$scope.$parent.$parent.$parent.$parent.$parent.$ctrl.items;
        public choiceQuestion = this.$scope.$parent.$parent.$parent.$ctrl.item;

        constructor(private MediaUploadService: MediaUploadService, private EmbedService: EmbedService, private $sce: ISCEService, private $scope: IScope) {

        }

        convertTo(type) {
            this.item.type = type;
        }

        moveToQuestion(questionIndex) {
            this.$scope.$applyAsync(() => {
                this.$scope.$parent.$parent.$parent.$parent.$parent.$ctrl.items[questionIndex].choices.push(this.item);
                this.$scope.$parent.$parent.$ctrl.deleteChoice(this.index, true);

                this.$scope.$parent.$parent.$parent.$parent.$parent.$apply();
                this.$scope.$parent.$parent.$apply();
            });
        }

        $onInit() {

        }

        discover(url) {
            //@PRO
            this.processing = true;
            this.embed = null;

            this.EmbedService.fetch(url)
                .then((providerResponse) => {
                    this.embed = providerResponse;
                })
                .catch(() => {
                    if (this.item[this.item.type]) {
                        this.item[this.item.type].html = null;
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
            //@END-PRO
        }

        dismissEmbed() {
            this.embed = null;
        }

        escape(content) {
            return this.$sce.trustAsHtml(content);
        }

        importEmbed() {
            this.item.label = this.embed.title;
            this.item[this.item.type] = {
                full: this.embed.url,
                thumbnail: this.embed.thumbnail_url,
                html: this.embed.html
            };

            this.embed = null;
        }

        isCollapsed() {
            return this.item.collapsed;
        }

        isVisible() {
            return this.item.visibility;
        }

        prefix(content, separator = '-') {
            return `${this.item.uid}${separator}${content}`;
        }

        suffix(content, separator = '-') {
            return `${content}${separator}${this.item.uid}`;
        }

        toggleCollapsed() {
            this.item.collapsed = !this.item.collapsed;
        }

        toggleVisibility() {
            this.item.visibility = !this.item.visibility;
        }

        upload(context = 'full', type = this.item.type) {
            //@PRO
            this.MediaUploadService.open(type).then((attachment) => {
                // Get media object
                if (!attachment) {
                    return;
                }
                // Create object
                if (!this.item[this.item.type]) {
                    this.item[this.item.type] = {};
                }
                // Available sizes
                let availableSizes = attachment.get('sizes');
                // Sizes
                if (availableSizes) {
                    this.item[this.item.type].sizes = availableSizes;
                }
                // Id
                this.item[this.item.type].attachmentId = attachment.get('id');
                if (context === 'full') {
                    // Full image
                    this.item[this.item.type].full = attachment.get('url');
                    // Thumbnail
                    if (this.item.type === 'image' && availableSizes && availableSizes.thumbnail) {
                        if (!this.item[this.item.type].thumbnail || (this.item[this.item.type].thumbnail != availableSizes.thumbnail.url && confirm('Override thumbnail URL?'))) {
                            this.item[this.item.type].thumbnail = availableSizes ? availableSizes.thumbnail.url : '';
                        }
                    }
                    // Label
                    if (this.item.label.trim().length === 0) {
                        this.item.label = attachment.get('title ') || attachment.get('name');
                    }
                    // Delete embed HTML, if any
                    delete this.item[this.item.type].html;
                } else if (context == 'thumbnail') {
                    // Thumbnail
                    this.item[this.item.type].thumbnail = availableSizes ? availableSizes.thumbnail.url : '';
                }
            });
            //@END-PRO
        }
    }
}
